<template>
  <div>
    <component
      v-for="field in customFields"
      :key="field.id"
      :is="getFieldComponent(field)"
      :options="field"
      :id="`personal-information__custom-field--${field.id}`"
      :class="['personal-information-custom-field', 'cac-input-wrapper__list-group--item', field.inputType]"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Constants
import STATE from "Constants/campaign/civicactioncenter/state";
import CUSTOM_FIELDS from "Constants/campaign/civicactioncenter/customFields";

// Components
import CustomTextArea from "CivicActionCenterComponents/shared/PersonalInformation/CustomFields/CustomTextArea.vue";
import CustomTextField from "CivicActionCenterComponents/shared/PersonalInformation/CustomFields/CustomTextField.vue";
import CustomSelect from "CivicActionCenterComponents/shared/PersonalInformation/CustomFields/CustomSelect.vue";
import CustomRadio from "CivicActionCenterComponents/shared/PersonalInformation/CustomFields/CustomRadio.vue";
import CustomCheckbox from "CivicActionCenterComponents/shared/PersonalInformation/CustomFields/CustomCheckbox.vue";

const customFieldsContext = `${STATE.SCOPE_FORMS}/${STATE.CUSTOM_FIELDS}`;

const customFieldsComponents = {
  [CUSTOM_FIELDS.HELPER_TEXT_FIELD_KEY]:
    CUSTOM_FIELDS.CUSTOM_TEXT_FIELD_COMPONENT_NAME,
  [CUSTOM_FIELDS.HELPER_TEXT_AREA_KEY]:
    CUSTOM_FIELDS.CUSTOM_TEXT_AREA_COMPONENT_NAME,
  [CUSTOM_FIELDS.HELPER_RADIO_KEY]: CUSTOM_FIELDS.CUSTOM_RADIO_COMPONENT_NAME,
  [CUSTOM_FIELDS.HELPER_SELECT_KEY]: CUSTOM_FIELDS.CUSTOM_SELECT_COMPONENT_NAME,
  [CUSTOM_FIELDS.HELPER_CHECKBOX_KEY]: CUSTOM_FIELDS.CUSTOM_CHECKBOX_KEY
};

export default {
  name: "CustomFields",
  components: {
    CustomTextArea,
    CustomTextField,
    CustomSelect,
    CustomRadio,
    CustomCheckbox
  },
  inject: {
    formHelper: { from: "formHelper" }
  },
  computed: {
    ...mapGetters({
      customFields: customFieldsContext
    })
  },
  methods: {
    getFieldComponent(field) {
      return customFieldsComponents[this.formHelper.getFieldType(field)];
    }
  }
};
</script>
